import React from 'react';
import { motion } from 'framer-motion';
import { architectureLayers } from '../../data/mockData';

export default function ArchBlueprint() {
  return (
    <div className="border border-zinc-800 rounded-lg overflow-hidden">
      {/* Table Header */}
      <div className="grid grid-cols-3 gap-0 bg-zinc-900/80 border-b border-zinc-800">
        <div className="px-4 py-3 text-[10px] font-bold tracking-widest text-amber-400 uppercase border-r border-zinc-800">
          Operational Layer
        </div>
        <div className="px-4 py-3 text-[10px] font-bold tracking-widest text-cyan-400 uppercase border-r border-zinc-800">
          Core Mechanism
        </div>
        <div className="px-4 py-3 text-[10px] font-bold tracking-widest text-fuchsia-400 uppercase">
          Technical Reality
        </div>
      </div>

      {/* Table Rows */}
      {architectureLayers.map((row, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.15 }}
          className="grid grid-cols-3 gap-0 border-b border-zinc-800/50 last:border-0 hover:bg-zinc-900/30 transition-colors"
        >
          <div className="px-4 py-4 border-r border-zinc-800/50">
            <span className="text-xs font-bold text-zinc-100">{row.layer}</span>
          </div>
          <div className="px-4 py-4 border-r border-zinc-800/50">
            <p className="text-[11px] text-zinc-400 leading-relaxed">{row.mechanism}</p>
          </div>
          <div className="px-4 py-4">
            <p className="text-[11px] text-zinc-500 font-mono leading-relaxed">{row.reality}</p>
          </div>
        </motion.div>
      ))}
    </div>
  );
}